export const EDITABLE_PROFILE_FIELDS = [
  'nombreCreativo',
  'perfilClave',
  'demografiaPrincipal',
  'interesesPrincipales',
  'vehiculos',
  'descripcionEjemplificada',
  'comportamientoPropenso',
];

export const FIELD_LABELS = {
  nombreCreativo: '¿Cómo es éste perfil?',
  perfilClave: 'Perfil Clave',
  demografiaPrincipal: 'Demografía Principal',
  interesesPrincipales: 'Intereses Principales',
  vehiculos: 'Vehículos',
  descripcionEjemplificada: 'Descripción detallada',
  comportamientoPropenso: 'Comportamiento de compra del segmento',
};

export function parsePerfilAmpliado(perfil_ampliado) {
  if (!perfil_ampliado) {
    return { type: 'plainText', data: { raw: '' } };
  }

  try {
    const parsed = JSON.parse(perfil_ampliado);
    if (typeof parsed === 'object' && parsed !== null) {
      return { type: 'json', data: parsed };
    }
  } catch {
    // legacy format
  }

  if (perfil_ampliado.includes('@@@')) {
    const parts = perfil_ampliado.split('@@@');
    return {
      type: 'legacyTitled',
      data: { title: parts[0], body: parts[1] || '' },
    };
  }

  return { type: 'plainText', data: { raw: perfil_ampliado } };
}

export function isPlainTextProfile(parsed) {
  return parsed?.type === 'plainText';
}

export function isLegacyTitledProfile(parsed) {
  return parsed?.type === 'legacyTitled';
}

export function serializePerfilAmpliado(parsed, editedFields) {
  if (parsed.type === 'json') {
    const merged = { ...parsed.data, ...editedFields };
    return JSON.stringify(merged);
  }

  if (parsed.type === 'legacyTitled') {
    return `${editedFields.title ?? parsed.data.title ?? ''}@@@${editedFields.body ?? parsed.data.body ?? ''}`;
  }

  return editedFields.raw ?? parsed.data.raw ?? '';
}

export function cloneProfileArray(profiles) {
  if (!profiles) return [];
  return profiles.map((item) => ({ ...item }));
}

export function profilesHaveChanges(original, edited) {
  if (!original || !edited) return false;
  if (original.length !== edited.length) return true;
  return original.some((item, index) => {
    return JSON.stringify(item) !== JSON.stringify(edited[index]);
  });
}

export function updateProfileField(profiles, index, field, value) {
  const next = cloneProfileArray(profiles);
  const item = { ...next[index] };
  const parsed = parsePerfilAmpliado(item.perfil_ampliado);

  if (parsed.type === 'json') {
    const editedFields = { ...parsed.data, [field]: value };
    item.perfil_ampliado = serializePerfilAmpliado(parsed, editedFields);
  } else if (field === 'raw') {
    item.perfil_ampliado = value;
  } else if (field === 'body') {
    item.perfil_ampliado = serializePerfilAmpliado(parsed, {
      title: parsed.data.title,
      body: value,
    });
  } else if (field === 'title' || field === 'nombreCreativo') {
    item.perfil_ampliado = serializePerfilAmpliado(parsed, {
      title: value,
      body: parsed.data.body ?? '',
    });
  }

  next[index] = item;
  return next;
}

export function updateLegacyProfileText(profiles, index, value) {
  const next = cloneProfileArray(profiles);
  next[index] = { ...next[index], perfil_ampliado: value };
  return next;
}
